import { collection, query, where } from 'firebase/firestore';
import { firestore } from '../../firebase/firebase';
import { chatPaths } from '../../firebase/chat/chatsPath';

const getChatsInNeedOfHelpQuery = (authorizedUser) => {
  return query(collection(firestore, chatPaths.chatCollection), where('needHelp', '==', true));
};

export default getChatsInNeedOfHelpQuery;